var map = {
	"./banner-image.png": 5178,
	"./holiday-1-thumb.jpg": 798,
	"./holiday-1.jpg": 8036,
	"./holiday-2-thumb.jpg": 1101,
	"./holiday-2.jpg": 8445,
	"./holiday-3-thumb.jpg": 1541,
	"./holiday-3.jpg": 290,
	"./travelsite-logo.png": 8145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;